import client from "./client";

export default {

    async getBills(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/bills', filters)));
    },
    async getBill(id) {
        return client.parseResponse(await client.get('/bills/' + id));
    },
    async createBill(data) {
        return client.parseResponse(await client.post('/bills', data))
    },
    async editBill(data) {
        return client.parseResponse(await client.put('/bills/' + data.id, data))
    },
    async deleteBill(data) {
        return client.parseResponse(await client.delete('/bills/' + data.id))
    },

    async getBillsReview(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/bills/review', filters)));
    },
    async sendBills(data) {
        return client.parseResponse(await client.post('/bills/send', data));
    },

    async exportBillsReport(filters) {
        return client.parseResponse(await client.get('/export-bills', filters, {responseType: 'blob'}));
    }
}
